import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PayoutItemContent from './PayoutItemContent/PayoutItemContent.container';
import { I18nContext } from 'utils/I18n/context';

const PayoutItemPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.payoutItemPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <PayoutItemContent />
            </section>
        </React.Fragment>
    );
};

export default PayoutItemPage;
